
@if (approvalSteps.length>0) {
  <sabis-ngx-dialog scTitle="Approvals">
    <div modal-body>
      <mat-stepper orientation="vertical" #stepper>
        @for (step of approvalSteps; track step) {
          <mat-step>
            <ng-template matStepLabel>{{ step.summary }}</ng-template>
          </mat-step>
        }
      </mat-stepper>
    </div>
  </sabis-ngx-dialog>
} @else {
  <sabis-ngx-dialog scTitle="Info">
    <div modal-body>
      <span>There are no available workflows for this hiring request at the moment.</span></div>
    </sabis-ngx-dialog>
}
